import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  EventEmitter,
  DOCUMENT,
  ChangeDetectionStrategy
} from '@angular/core';

import { ISideNavList } from './side-nav-list';
import { IExternalNavList } from './external-nav-list';
import { EnvironmentService } from '../environment/environment.service';
import { AuthService } from '../auth/auth.service';
import { User } from '../interfaces/user';
import { CurrentUserService } from '../services/current-user.service';
import { PageTitleService } from '../services/page-title.service';
import { sidenav_global_pipelines } from './graphql/sidenavGlobalPipelines';
import { Observer, Subscription } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { JumpToTopComponent } from '../components/jump-to-top/jump-to-top.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const GET_GLOBAL_PIPELINES = sidenav_global_pipelines;
const PROGRESS_ZAPPY_TICKS = 10;

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SideNavComponent implements OnInit {
  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;
  @ViewChild(JumpToTopComponent) jumpToTop: JumpToTopComponent;
  user: User;
  private userSub: Subscription;
  private querySubscription: Subscription = new Subscription();
  private urlSub: Subscription;
  constructor(
    public env: EnvironmentService,
    public authService: AuthService,
    public currentUserService: CurrentUserService,
    public titleService: PageTitleService,
    private apollo: Apollo,
    public document: Document,
    private route: ActivatedRoute
  ) {}

  public navlist: Array<ISideNavList> = [];
  public externalList: Array<IExternalNavList> = [];

  public loadingtime: number = 0;

  public justfinished: boolean = false;
  public justfinishedtime: number = 0;

  public loadingInterval: any;

  ngOnInit(): void {
    let creaRedirect: string = this.env.jupiter_url;
    let globalPipelines: any = [];
    let pipelineSub = (this.querySubscription = this.apollo
      .watchQuery<any>({
        query: GET_GLOBAL_PIPELINES,
      })
      .valueChanges.subscribe(({ data }) => {
        globalPipelines.length = 0;
        if (data && data.pipelineViewFilters.length) {
          for (let i = 0; i < data.pipelineViewFilters.length; i++) {
            globalPipelines.push({
              name: data.pipelineViewFilters[i].name,
              link:
                '/pipeline/' + data.pipelineViewFilters[i].id,
              icon: '',

              data: undefined,
            });
          }
        }
        globalPipelines.push({
          name: 'Pricing Tracker',
          link: 'https://app.powerbi.com/groups/me/apps/ef49264e-6a0c-422c-903a-35546a1ffcf8/reports/fe883309-510d-4ceb-9229-badb040fa186/',
          icon: '',
          newTab: true,
          isExpandable: false,
          expanded: false,
          data: undefined,
        });
        if(data){
          pipelineSub.unsubscribe();
        }
      }));

    this.loadingInterval = setInterval(() => {
      if (!this.loadingtime) {
        this.loadingtime = 0;
      }
      if (this.justfinished && this.justfinishedtime < PROGRESS_ZAPPY_TICKS) {
        this.justfinishedtime += 1;
      }
      if (this.justfinished && this.justfinishedtime >= PROGRESS_ZAPPY_TICKS) {
        this.justfinished = false;
        this.justfinishedtime = 0;
      }
      if (this.authService.call_running > 0) {
        this.loadingtime += 1;
        this.justfinished = false;
        this.justfinishedtime = 0;
      } else {
        if (this.loadingtime > 0) {
          this.justfinished = true;
          this.justfinishedtime = 0;
          this.loadingtime = 0;
        }
      }
      let face = this.document.getElementById('progress_bar');

      if (!this.justfinished && this.loadingtime > 0) {
        if (
          face &&
          face.style.width !== Math.min(this.loadingtime / 4.0, 97) + '%'
        ) {
          face.style.width = Math.min(this.loadingtime / 4.0, 97) + '%';
        }
      } else if (this.justfinished) {
        if (face && face.style.width !== '100%') {
          face.style.width = '100%';
        }
      } else {
        if (face) {
          face.style.width = '0%';
        }
      }
    }, 33);
    this.currentUserService.updateCurrentUserInToken();

    this.navlist = [
      {
        name: 'Committee Calendar',
        routerLink: '/main',
        icon: 'calendar_month',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Company Events',
        routerLink: '/company_events/calendar',
        icon: 'event_available',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Dashboard',
        routerLink: '/dashboard',
        icon: 'speed',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Pipelines',
        link: '/pipeline',
        icon: 'view_timeline',
        isExpandable: true,
        expanded: false,
        data: globalPipelines,
      },
      {
        name: 'Credit Outlets',
        link: '/credit_outlets',
        icon: 'account_balance',
        isExpandable: true,
        expanded: false,
        data: [
          {
            name: 'Credit Outlets',
            link: '/credit_outlets',
            icon: '',
            isExpandable: false,
            expanded: false,
            data: undefined,
          },
          {
            name: 'Syndications Pipeline',
            link: '/syndications',
            icon: '',
            isExpandable: false,
            expanded: false,
            data: undefined,
          },
        ],
      },
      {
        name: 'Consents',
        routerLink: '/consents',
        icon: 'approval',
        isExpandable: true,
        expanded: false,
        data: [
          {
            name: 'Consent Requests',
            routerLink: '/consents/requests',
            icon: 'approval',
            isExpandable: false,
            expanded: false,
            data: undefined,
          },
          {
            name: 'Consent Checklists',
            routerLink: '/consents/checklists',
            icon: 'checklist',
            isExpandable: false,
            expanded: false,
          },
          {
            name: 'Investor Approvals',
            routerLink: '/consents/investors',
            icon: 'how_to_vote',
            isExpandable: false,
            expanded: false,
          },
        ],
      },
      {
        name: 'Documents',
        routerLink: '/documents',
        icon: 'tab',
        isExpandable: true,
        expanded: false,
        data: [
          {
            name: 'Tracking',
            routerLink: '/documents/tracking',
            icon: '',
            isExpandable: false,
            expanded: false,
          },
          {
            name: 'Requirements',
            routerLink: '/documents/requirements',
            icon: '',
            isExpandable: false,
            expanded: false,
          },
        ],
      },
      {
        name: 'Contacts',
        link: '/contacts/people',
        icon: 'people',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Diligence',
        link: '/diligence',
        icon: 'check_box',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Dispositions',
        routerLink: '/dispositions',
        icon: 'handshake',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
      {
        name: 'Reporting',
        link: 'https://app.powerbi.com/home?tenant=91d5341e-e81c-43b7-bdfa-d865952d2de4',
        icon: 'library_books',
        isExpandable: false,
        expanded: false,
        data: undefined,
      },
    ];

    this.externalList = [
      {
        name: 'CREALink',
        link: 'https://crealink.crm.dynamics.com/apps/CREALink',
      },
      {
        name: 'Help Center',
        link: 'https://creallc.monday.com/portal'
      },
      {
        name: 'Reporting',
        link: 'https://app.powerbi.com/home?tenant=91d5341e-e81c-43b7-bdfa-d865952d2de4',
      },
      {
        name: 'Investment Central',
        link: 'https://crea.investment.mrisoftware.com',
      },
      {
        name: 'CREAIntranet',
        link: 'https://creallc.sharepoint.com/SitePages/Home.aspx',
      },
      {
        name: 'CREAPortal',
        link: 'https://creallc.sharepoint.com/sites/portal/Pages/default.aspx',
      },
      {
        name: 'CREA, LLC',
        link: 'https://creallc.com',
      },
      {
        name: 'Investor Connect (Reporting Central)',
        link: 'https://crea.investorconnect.mrisoftware.com',
      },
      {
        name: 'Employee Directory',
        link: 'https://creallc.sharepoint.com/SitePages/Directory.aspx',
      },
      {
        name: 'Paylocity',
        link: 'https://login.paylocity.com/escher/escher_webui/views/login/login.aspx',
      },
      {
        name: "CREAWeb Status",
        link: 'https://creaservicesstatus-1776443586426.site24x7statusiq.com/'
      }
    ];
    this.urlSub = this.route.url.subscribe((url) => {
      let index = this.navlist.findIndex(
        (item) => item.isExpandable && item.routerLink === '/' + (url[0]?.path ?? '')
      );
      if (index > -1) {
        this.navlist[index].expanded = true;
      }
    });
    this.userSub = this.currentUserService.getUser().subscribe((user) => {
      if (user) {
        this.user = user;
      }
    });
  }
  ngAfterViewInit() {
    this.drawerContainer.scrollable.elementScrolled().subscribe((event) => {
      this.jumpToTop.handleScroll(event);
    });
  }
  creawebRedirect(link: string) {
    this.document.location.assign(link);
  }
  externalRedirect(link: string) {
    window.open(link, '_blank');
  }

  logout() {
    this.authService.logout();
  }
  scrollTo($event: string) {
    this.drawerContainer.scrollable.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  ngDestroy() {
    clearInterval(this.loadingInterval);
    this.userSub && this.userSub.unsubscribe;
    this.querySubscription && this.querySubscription.unsubscribe();
    this.urlSub?.unsubscribe();
  }
}
